import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import { Alert, Col, Layout, Row } from 'antd';
import CenteredLoadingScreen from 'components/CenteredLoadingScreen';
import { useRef, useState } from 'react';
import { PersonToPob } from '../PersonToPob';
import './style.less';

const { Content, Header } = Layout;

export interface EditPobProps {
	pobNodeID: any;
	headerExtra?: React.ReactNode[];
}

const EditPob: React.FC<EditPobProps> = (props) => {
	const { pobNodeID, headerExtra } = props;

	const [hasSubmitError, setHasSubmitError] = useState(false);
	// const [hasSubmitSuccess, setHasSubmitSuccess] = useState(false);
	// const [refetchPerson, setRefetchPerson] = useState(false);
	// const [hasSearched, setHasSearched] = useState(false);
	const pobEditor = useRef(null);

	const pobNodeResult = useQuery(
		gql`
			query GetPerson($pobNodeID: ID!) {
				getPobNode(_id: $pobNodeID) {
					_id
					personID {
						_id
						lastName
						firstName
						customerID {
							_id
							name
						}
						employerID {
							_id
							name
						}
						dob
					}
					lastName
					firstName
					customerID {
						_id
						name
					}
					employerID {
						_id
						name
					}
					contractID {
						_id
						name
					}
					currentJobTitle
					onRigContactPhone {
						type
						number
					}
					currentlyEssential
				}
			}
		`,
		{
			variables: {
				pobNodeID: pobNodeID,
			},
			fetchPolicy: 'network-only',
		},
	);

	const pobNodeData = pobNodeResult?.data?.getPobNode;

	// useEffect(() => {
	//     setHasSubmitError(props.submitError ? true : false);
	// }, [props.submitError])

	// useEffect(() => {
	//     setHasSubmitSuccess(props.submitSuccess ? true : false);
	//     if (props.submitSuccess) {
	//         pobEditor.current.resetFields();
	//         setRefetchPerson(true);
	//     }
	// }, [props.submitSuccess])

	// const validatePaxEditor = (additionalFields) => (err, values) => {
	//     if (!err) {
	//         const formattedValues = formatPersonToPobValues(values);
	//         props.onSubmit && props.onSubmit({
	//             ...formattedValues,

	//             // @ts-ignore
	//             personID: selectedPerson,
	//             ...additionalFields
	//         });
	//     }
	// }

	// function handleSubmitBtnClick(additionalFields) {
	//     setHasSubmitError(false);
	//     setHasSubmitSuccess(false);
	//     pobEditor.current.validateFieldsAndScroll(validatePaxEditor(additionalFields));
	// }

	// if (typeof props.renderSubmitBtn === 'function') {
	//     submitBtn = props.renderSubmitBtn(handleSubmitBtnClick);
	// }

	let editor = (
		<PersonToPob
			ref={pobEditor}
			// @ts-ignore
			readonly={true}
			// @ts-ignore
			pobNodeData={pobNodeData}
			personData={pobNodeData?.personID}
		/>
	);

	if (pobNodeResult.loading) {
		editor = <CenteredLoadingScreen />;
	}

	if (pobNodeResult.error) {
		editor = (
			<>
				<Alert type='error' showIcon message='Failed to load person' style={{ marginBottom: 12 }} />
				{editor}
			</>
		);
	}

	return (
		<Layout style={{ height: '100%' }}>
			<Header className='ant-layout-header-small ant-layout-header-bordered'>
				<Row type='flex' gutter={12}>
					<Col>
						<h3 style={{ margin: 0 }}>Passenger Editor</h3>
					</Col>
					<Col style={{ marginLeft: 'auto' }}>
						{/* <Button
                            onClick={() => pobEditor.current.resetFields()}
                        >Reset</Button>
                        {submitBtn} */}
					</Col>
					{headerExtra}
				</Row>
			</Header>
			<Content style={{ padding: 12, overflow: 'auto' }}>
				{/* {hasSubmitSuccess ? (
                    <Alert
                        closable
                        showIcon
                        // type={props.submittedPassengerData ? 'success' : 'warning'}
                        style={{ marginBottom: 12 }}
                        message={
                            props.submittedPassengerData ?
                                `Passenger ${props.submittedPassengerData.lastName}, ${props.submittedPassengerData.firstName} successfully checked in`
                                :
                                'Got a successful response, but an empty result. Passenger may or may not have been created.'
                        }
                        onClose={() => setHasSubmitSuccess(false)}
                    />
                ) : null} */}
				{hasSubmitError ? (
					<Alert
						closable
						showIcon
						type='error'
						message='Failed to submit due to an error'
						style={{ marginBottom: 12 }}
						onClose={() => setHasSubmitError(false)}
					/>
				) : null}
				{editor}
			</Content>
		</Layout>
	);
};

export default EditPob;
